module.exports = __webpack_public_path__ + "img/aeromexico.0d2179bb.png";